module.exports = __webpack_public_path__ + "static/media/round-timer-04.511a2b22.svg";